import { request, requestJSON } from "../promises/library";
import { UPS_BASE_URL } from "./constants";

export const getBundle = (userId, bundleId) => {
    if (!userId) {
        return Promise.reject(`invalid user id - ${userId}`);
    }
    if (!bundleId) {
        return Promise.reject(`invalid bundle id - ${bundleId}`);
    }

    return requestJSON(
        `${UPS_BASE_URL}/UIEUser/${userId}/UPSPreferences/${bundleId}`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }
    );
};

export const setBundle = (userId, bundleId, preferences) => {
    if (!userId) {
        return Promise.reject(`invalid user id - ${userId}`);
    }
    if (!bundleId) {
        return Promise.reject(`invalid bundle id - ${bundleId}`);
    }

    return request(
        `${UPS_BASE_URL}/UIEUser/${userId}/UPSPreferences/${bundleId}`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(preferences),
        }
    );
};
